<template>
  <div class="FloorPlannerIframe desk:layout-container">
    <iframe
      class="w-full h-[calc(100dvh-128px)] desk:h-[calc(100dvh-137px)]"
      :src="materialoLink"
    />
  </div>
</template>

<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';
const globalContent = useGlobalContentStore();

const { $t } = useNuxtApp();

const props = defineProps<{
  art_nr: string,
  art_name: string,
  design?: string | null,
  surface?: string | null,
  construction?: string | null,
}>();

const materialoLink = computed(()=> {
  const query = [] as string[];

  query.push('start_text='+$t('floorPlanner.headline1'));
  query.push('start_text2='+$t('floorPlanner.headline2'));
  query.push(`lng_str=${globalContent.getFloorPlannerLocale}`);
  // Not actually language but tld:
  if (globalContent.getCountryCode === 'us') {
    query.push('language=en');
  } else {
    query.push(`language=${globalContent.domainMap?.storyblokBasePath}`);
  }
  query.push('type=Floors');

  query.push(`art_nr=${props.art_nr}`);
  query.push(`art_name=${props.art_name}`);

  if (props.design) {
    query.push(`design=${props.design}`);
  }
  if (props.surface) {
    query.push(`surface=${props.surface}`);
  }
  if (props.construction) {
    query.push(`construction=${props.construction}`);
  }

  return `https://kahrs.materialo.com/?${encodeURI(query.join('&'))}`;
});

</script>

<style scoped lang="postcss">
</style>
